// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__96s57","text":"Tag_text__kIp5S","primary":"Tag_primary__LqLqy","success":"Tag_success__4nPSR","alert":"Tag_alert__e+RFu","danger":"Tag_danger__ypDeT"};